module.exports = __webpack_public_path__ + "static/media/eye-duotone.69549a69.svg";